/* eslint-disable camelcase */
/* eslint-disable dot-notation */
import { useEffect } from 'react';
import './tifluxChat.css';

declare global {
  interface Window {
    organization_token?: string;
    icon_color?: string;
    init_minimal?: string | boolean;
    show_chat_icon?: string | boolean;
    extra_params?: {
      margin_bottom?: number;
      margin_right?: number;
    };
  }
}

export default function TifluxChatLoader() {
  useEffect(() => {
    if (document.querySelector('script[data-tiflux-chat="true"]')) {
      return;
    }

    window.organization_token = '17acdb86db8e172f2b640b6338be3877a19edadd';
    window.icon_color = '#f39200';
    window.init_minimal = 'true';
    window.show_chat_icon = 'true';

    window.extra_params = {};

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://public-assets.tiflux.com/chat_widget.js?organization_token=${window.organization_token}`;
    script.setAttribute('data-tiflux-chat', 'true');

    document.head.appendChild(script);
  }, []);

  return null;
}
